import React, { Component, PropTypes } from 'react';
import get from 'lodash.get';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { geti18n } from '../../utils';
import { browserSizeSelector } from '../../redux/selectors';
import { getDealerActionFromState, updateDealerActionByZip } from '../../redux/actions/dealers';
import { getDealersObject, isQuerying, didQueryFail } from '../../redux/selectors/dealers';
import { isLeadSubmitting } from '../../redux/selectors/leads';
import { getCurrentZipCode } from '../../redux/selectors/dma';
import LoadingSpinner from '../LoadingSpinner';
import Paginator from '../Paginator';
import DealerCard from '../DealerCard';
import DealersListZipSearchForm from '../DealersListZipSearchForm';
import { updateZipCodeAction } from '../../redux/actions/zipCode';
import {
  dealersListLoadingSpinnerStyles,
  DealersListWrapperStyled,
  DealersListZipWrapperStyled,
  DealersListResultsPendingStyled,
  ClosestDealersTitle
} from './styles';
import ErrorSvg from '../LeadsForm/ErrorSvg';
import { GenericFormErrorStyled, GenericFormErrorSvgStyled } from '../LeadsForm/styles';

class DealersList extends Component {
  static propTypes = {
    closestDealers: PropTypes.string,
    noResultsText: PropTypes.string,
    resultsError: PropTypes.string,
    currentDealer: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object]),
    mediaType: PropTypes.string.isRequired,
    dealersObject: PropTypes.object,
    currentZipCode: PropTypes.string.isRequired,
    querying: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool]).isRequired,
    leadSubmitting: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool]).isRequired,
    makeDealerQueryRequest: PropTypes.func.isRequired,
    updateDealerByZip: PropTypes.func.isRequired,
    queryFailed: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool]),
    currentFormValues: PropTypes.object.isRequired,
    setCurrentZipCode: PropTypes.func.isRequired
  };
  static defaultProps = {
    closestDealers: geti18n('leadsFormContent.dealerList.closestDealer'),
    results: geti18n('leadsFormContent.dealerList.results'),
    noResultsText: geti18n('leadsFormContent.dealerList.noResults'),
    resultsError: geti18n('leadsFormContent.dealerList.resultsError'),
    currentDealer: {},
    dealersObject: {},
    queryFailed: ''
  };

  componentDidMount() {
    const { currentFormValues, makeDealerQueryRequest, setCurrentZipCode } = this.props;
    setCurrentZipCode(currentFormValues.postalCode);
    makeDealerQueryRequest();
    window.scrollTo(0, 0);
  }

  render() {
    const {
      currentDealer,
      mediaType,
      dealersObject,
      currentZipCode,
      querying,
      leadSubmitting,
      makeDealerQueryRequest,
      updateDealerByZip,
      queryFailed,
      closestDealers,
      noResultsText,
      resultsError
    } = this.props;
    const totalDealers = get(dealersObject, 'totalResults', null);
    const noResults = totalDealers === 0;
    const shouldRenderDealerList = dealersObject && totalDealers > 0 && !leadSubmitting;
    const shouldRenderResultsFound = !querying && totalDealers !== null && !leadSubmitting;
    if (!currentZipCode || leadSubmitting) {
      return (
        <LoadingSpinner
          shouldAnimate={querying || leadSubmitting}
          withContainer={dealersListLoadingSpinnerStyles}
        />
      );
    }
    return (
      <DealersListWrapperStyled>
        <DealersListZipWrapperStyled>
          <DealersListZipSearchForm
            currentZipCode={currentZipCode}
            makeDealerQueryRequest={makeDealerQueryRequest}
            isQuerying={querying}
            updateDealerByZip={updateDealerByZip}
          />
        </DealersListZipWrapperStyled>
        {shouldRenderResultsFound && (
          <ClosestDealersTitle>{closestDealers}</ClosestDealersTitle>
        )}
        {shouldRenderDealerList && (
          <Paginator data={dealersObject.dealers} mediaType={mediaType} itemsPerList={3}>
            <DealerCard currentDealer={currentDealer} />
          </Paginator>
        )}
        <LoadingSpinner
          shouldAnimate={querying || leadSubmitting}
          withContainer={dealersListLoadingSpinnerStyles}
        />
        {(queryFailed || noResults) &&
          !querying && (
            <DealersListResultsPendingStyled>
              <GenericFormErrorStyled dealerList={true}>
                <GenericFormErrorSvgStyled>
                  <ErrorSvg />
                </GenericFormErrorSvgStyled>
                {noResults
                  ? { noResultsText }
                  : { resultsError }}
              </GenericFormErrorStyled>
            </DealersListResultsPendingStyled>
          )}
      </DealersListWrapperStyled>
    );
  }
}

const mapStateToProps = state => ({
  mediaType: browserSizeSelector(state),
  dealersObject: getDealersObject(state),
  currentZipCode: getCurrentZipCode(state),
  querying: isQuerying(state),
  queryFailed: didQueryFail(state),
  leadSubmitting: isLeadSubmitting(state)
});

const mapDispatchToProps = dispatch => ({
  setCurrentZipCode: bindActionCreators(updateZipCodeAction, dispatch),
  makeDealerQueryRequest: bindActionCreators(getDealerActionFromState, dispatch),
  updateDealerByZip: bindActionCreators(updateDealerActionByZip, dispatch)
});

export default (connect(mapStateToProps, mapDispatchToProps)(DealersList));



/** WEBPACK FOOTER **
 ** ./src/components/DealersList/index.js
 **/